export const SET_AVAILABLE_REPORTS = 'SET_AVAILABLE_REPORTS';
export const SET_REPORT_DATA       = 'SET_REPORT_DATA';

